import * as React from 'react';
import * as moment from 'moment';
import { DateRangePicker } from 'react-dates';
import 'react-dates/lib/css/_datepicker.css';
import styled from 'styled-components';
import MediaQuery from 'react-responsive';

const StyledWrapper = styled.div`
  display: flex;
  flex-direction: column;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  font-size: 11px;
  height: 64px;
  font-family: 'Inter UI', sans-serif;

  color: #828282;
  background: #ffffff;
  border: 1px solid #bdbdbd;
  box-sizing: border-box;
  border-radius: 4px;

  span {
    margin-top: 8px;
    margin-left: 16px;
  }

  .DateInput {
    width: 104px;
    margin-left: 12px;
  }

  .DateRangePicker_picker {
    top: 65px !important;
  }

  .DateRangePickerInput {
    border: none;
    border-radius: 0px;
    margin-left: 4px;
  }

  .DateInput_input {
    padding-left: 0px;
    font-size: 1rem;
    padding-top: 8px;
    padding-bottom: 6px;
  }

  .DateInput_input__focused {
    border-bottom: 2px solid #00144d;
  }

  .CalendarDay__hovered_span,
  .CalendarDay__hovered_span:hover {
    background: #8089a6;
    border: 1px solid #00144d;
    color: #00144d;
  }

  .CalendarMonth_caption strong {
    font-weight: 400;
  }

  .DayPickerKeyboardShortcuts_show__bottomRight {
    display: none;
  }

  .CalendarDay__selected,
  .CalendarDay__selected:active,
  .CalendarDay__selected:hover {
    background: #00144d;
    border: 1px solid #00144d;
    color: #fff;
  }

  .CalendarDay__selected_span {
    background: #334371;
    border: 1px solid #00144d;
    color: #fff;
  }

  .CalendarDay__selected_span:active,
  .CalendarDay__selected_span:hover {
    background: #334371;
    border: 1px solid #00144d;
    color: #fff;
  }
`;

const DatePickerText = styled.span`
  margin-left: 11px;
`;

interface props {
  style?: React.CSSProperties;
  startDate?: moment.Moment | null;
  endDate?: moment.Moment | null;
  onChange?: (startDate: moment.Moment | null, endDate: moment.Moment | null) => void;
  title?: String;
}

interface state {
  startDate: moment.Moment | null;
  endDate: moment.Moment | null;
  focusInput: 'startDate' | 'endDate' | null;
}

export default class DatePicker extends React.Component<props, state> {
  constructor(props: props) {
    super(props);

    this.state = {
      startDate: this.props.startDate || moment(),
      endDate: this.props.endDate || null,
      focusInput: null,
    };
  }

  render() {
    return (
      <StyledWrapper style={this.props.style}>
        <DatePickerText>{this.props.title || 'Date Range'}</DatePickerText>
        <MediaQuery query="(max-device-width: 768px)">
          <DateRangePicker
            startDate={this.state.startDate}
            startDateId="start_date"
            endDate={this.state.endDate}
            endDateId="end_date"
            onDatesChange={date => {
              this.props.onChange && this.props.onChange(date.startDate, date.endDate);
              this.setState({ startDate: date.startDate, endDate: date.endDate });
            }}
            focusedInput={this.state.focusInput}
            onFocusChange={(focusedInput: any) => this.setState({ focusInput: focusedInput })}
            orientation={'vertical'}
          />
        </MediaQuery>
        <MediaQuery query="(min-device-width: 769px)">
          <DateRangePicker
            startDate={this.state.startDate}
            startDateId="start_date"
            endDate={this.state.endDate}
            endDateId="end_date"
            onDatesChange={date => {
              this.props.onChange && this.props.onChange(date.startDate, date.endDate);
              this.setState({ startDate: date.startDate, endDate: date.endDate });
            }}
            focusedInput={this.state.focusInput}
            onFocusChange={(focusedInput: any) => this.setState({ focusInput: focusedInput })}
          />
        </MediaQuery>
      </StyledWrapper>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/FormComponents/DatePicker.tsx